const lsg_buybox_rebuild = { 
    init: () => {
        


        function imgURL(src, size) {
            // remove any current image size then add the new image size
            return src
                .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|200x200|1024x1024|2048x2048|master)+\./g, '.')
                .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
                    return '_'+size+match;
                })
            ;
        }

        const buyboxSectionEls  = document.querySelectorAll(`.lsg-buybox-rebuild`),
              debug             = false;

        buyboxSectionEls.forEach((buyboxSectionEl) => {

            if (debug) console.log(`[LSG] Processing buybox section.`);

            /* Gallery */
            const carouselEl = new Flickity(buyboxSectionEl.querySelector(`.lsg-buybox-rebuild__gallery`), {
                wrapAround: true,
                groupCells: true,
                pageDots: false,
                prevNextButtons: false,
                setGallerySize: false
            });

            carouselEl.on(`change`, (index) => {
                if (debug) console.log(`[LSG] Carousel change event.`);
                updateNav(index);
            });

            let carouselNavEl       = buyboxSectionEl.querySelector(`[lsg-carousel-nav]`),
                navPrevEl           = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`),
                navDotsEl           = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`),
                navDotEls           = navDotsEl.querySelectorAll(`[lsg-carousel-nav-dot]`),
                navNextEl           = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
    
            // Nav Handling
            function initNav(element, initialIndex) {

                if (debug) console.log(`[LSG] Initilizing carousel nav.`);

                carouselNavEl     = element.querySelector(`[lsg-carousel-nav]`);
                navPrevEl         = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`);
                navDotsEl         = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`);
                navDotEls         = navDotsEl.querySelectorAll(`[lsg-carousel-nav-dot]`);
                navNextEl         = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
                updateNav(initialIndex);
            }
            initNav(buyboxSectionEl, 0);

            function updateNav(index) {

                if (debug) console.log(`[LSG] Updating carousel nav.`);

                navDotEls.forEach((navDotEl) => {
                    navDotEl.parentElement.classList.remove(`lsg-dot-selected`);
                });

                const currentNavDotEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dot-index="${index}"]`);
                currentNavDotEl?.parentElement.classList.add(`lsg-dot-selected`);

                navPrevEl.removeAttribute(`disabled`);
                navNextEl.removeAttribute(`disabled`);

                if (!carouselEl.isWrapping && index === 0) {
                    navPrevEl.setAttribute(`disabled`, true);
                } else if (!carouselEl.isWrapping && index === carouselEl.cells.length - 1) {
                    navNextEl.setAttribute(`disabled`, true);
                }
            }

            navPrevEl.addEventListener(`click`, e => {
                carouselEl.previous();
                if (debug) console.log(`[LSG] Previous clicked, carouselEl:`, carouselEl);
            });

            navNextEl.addEventListener(`click`, e => {
                carouselEl.next();
                if (debug) console.log(`[LSG] Next clicked, carouselEl:`, carouselEl);
            });

            navDotEls.forEach((navDotEl) => {
                navDotEl.addEventListener(`click`, e => {
                    const index     = navDotEl.getAttribute(`lsg-carousel-nav-dot-index`);
                    carouselEl.select(index);
                    if (debug) console.log(`[LSG] Nav dot clicked, carouselEl:`, carouselEl);
                });
            });


            /* Buyboxes */
            const buyboxEls = buyboxSectionEl.querySelectorAll(`.lsg-buybox-rebuild__info`);

            buyboxEls.forEach((buyboxEl) => {

                /* Switcher */
                const switcherSelectEl = buyboxEl.querySelector(`[lsg-buybox-rebuild-switcher]`);

                switcherSelectEl.addEventListener(`change`, (e) => {

                    if (debug) console.log(`[LSG] Switcher changed.`);
                    if (debug) console.log(`[LSG] Switcher value:`, e.target.value);


                    /* Update Gallery */
                    if (debug) console.log(`[LSG] carouselEl.getCellElements():`, carouselEl.getCellElements());
                    carouselEl.remove(carouselEl.getCellElements());

                    const variantScriptEl = document.getElementById(`images-${e.target.value}`);
                    if (debug) console.log(`[LSG] variantScriptEl:`, variantScriptEl);
            
                    let variantImageData;
                    if (variantScriptEl) { variantImageData = JSON.parse(variantScriptEl.textContent); }

                    if (debug) console.log(`[LSG] variantImageData:`, variantImageData);

                    navDotsEl.innerHTML = '';

                    const newCells  = [];

                    variantImageData.forEach((image, i) => {

                        const slideEl           = document.createElement(`div`),
                              slideWrapperEl    = document.createElement(`div`),
                              slideImgEl        = document.createElement(`img`);
                        
                        slideEl.classList.add(`lsg-buybox-rebuild__gallery-slide`);
                        slideWrapperEl.classList.add(`lsg-buybox-rebuild__gallery-image-wrapper`);
                        slideImgEl.setAttribute(`src`, image);
                        slideImgEl.setAttribute(`alt`, ``);

                        slideWrapperEl.appendChild(slideImgEl);
                        slideEl.appendChild(slideWrapperEl);

                        newCells.push(slideEl);

                        const srcThumb = imgURL(image, '200x200');
                        if (debug) console.log(`[LSG] src:`, srcThumb);

                        const dotLiEl   = document.createElement(`li`),
                              dotBtnEl  = document.createElement(`button`),
                              dotImgEl  = document.createElement(`img`),
                              dotSpanEl = document.createElement(`span`);

                        dotLiEl.classList.add(`lsg-carousel-nav__dot`);

                        dotBtnEl.setAttribute(`type`, `button`);
                        dotBtnEl.setAttribute(`lsg-carousel-nav-dot`, ``);
                        dotBtnEl.setAttribute(`lsg-carousel-nav-dot-index`, i);

                        dotImgEl.setAttribute(`src`, srcThumb);
                        dotImgEl.setAttribute(`alt`, ``);

                        dotSpanEl.classList.add(`sr-only`);
                        dotSpanEl.textContent = `Slide ${i + 1} of ${variantImageData.length}`;

                        dotBtnEl.appendChild(dotImgEl);
                        dotBtnEl.appendChild(dotSpanEl);
                        dotLiEl.appendChild(dotBtnEl);

                        navDotsEl.appendChild(dotLiEl);

                        dotBtnEl.addEventListener(`click`, e => {
                            const index     = dotBtnEl.getAttribute(`lsg-carousel-nav-dot-index`);
                            carouselEl.select(index);
                            if (debug) console.log(`[LSG] Nav dot clicked, carouselEl:`, carouselEl);
                        });

                    });

                    carouselEl.append(newCells);
                    initNav(buyboxSectionEl, 0);
                    carouselEl.select(0);


                    /* Switch Buybox */
                    const changeTo          = e.target.value,
                          activeBuyboxEl    = buyboxSectionEl.querySelector(`.lsg-buybox-rebuild__buybox-active`),
                          targetBuyboxEl    = buyboxSectionEl.querySelector(`[lsg-buybox-rebuild-variant-id="${changeTo}"]`);
                    
                    e.target.value = activeBuyboxEl.getAttribute(`lsg-buybox-rebuild-variant-id`);
                    activeBuyboxEl.classList.remove(`lsg-buybox-rebuild__buybox-active`);
                    targetBuyboxEl.classList.add(`lsg-buybox-rebuild__buybox-active`);

                });

            });

        });


    }
}
export default lsg_buybox_rebuild;